import i18n from 'i18next';
import { DateTime } from 'luxon';

export const formatDate = date => DateTime.fromISO(date).setLocale(i18n.language).toFormat('D');
